/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 9.35418C14.2671 8.52375 13.1947 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458M7 11H12M7 13H11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill="currentColor"
			/>
			<path
				d="M8.12602 13C8.57006 14.7252 10.1362 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458M8.12602 13C8.04375 12.6804 8 12.3453 8 12C8 11.6547 8.04375 11.3196 8.12602 11M8.12602 13H7M8.12602 13H11M8.12602 11C8.57006 9.27477 10.1362 8 12 8C13.1947 8 14.2671 8.52375 15 9.35418M8.12602 11H7M8.12602 11H12M22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22V22C17.5228 22 22 17.5228 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM8.74988 12C8.74988 11.9159 8.75307 11.8325 8.75935 11.75H11.9999C12.4141 11.75 12.7499 11.4142 12.7499 11C12.7499 10.5858 12.4141 10.25 11.9999 10.25H9.26079C9.83832 9.34792 10.8493 8.75 11.9999 8.75C12.9705 8.75 13.841 9.17452 14.4376 9.85048C14.7117 10.161 15.1856 10.1906 15.4962 9.91648C15.8067 9.64238 15.8363 9.16843 15.5622 8.85788C14.6929 7.87299 13.4187 7.25 11.9999 7.25C9.99453 7.25 8.27942 8.49269 7.58263 10.25H6.99988C6.58566 10.25 6.24988 10.5858 6.24988 11C6.24988 11.4142 6.58566 11.75 6.99988 11.75H7.25634C7.25205 11.8328 7.24988 11.9161 7.24988 12C7.24988 12.0839 7.25205 12.1672 7.25634 12.25H6.99988C6.58566 12.25 6.24988 12.5858 6.24988 13C6.24988 13.4142 6.58566 13.75 6.99988 13.75H7.58263C8.27942 15.5073 9.99453 16.75 11.9999 16.75C13.4187 16.75 14.6929 16.127 15.5622 15.1421C15.8363 14.8316 15.8067 14.3576 15.4962 14.0835C15.1856 13.8094 14.7117 13.839 14.4376 14.1495C13.841 14.8255 12.9705 15.25 11.9999 15.25C10.8493 15.25 9.83832 14.6521 9.26079 13.75H10.9999C11.4141 13.75 11.7499 13.4142 11.7499 13C11.7499 12.5858 11.4141 12.25 10.9999 12.25H8.75935C8.75307 12.1675 8.74988 12.0841 8.74988 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 2.83209C14.7751 2.2969 13.4222 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.74835 21.2558 7.67051 20 5.99902M15 9.35418C14.2671 8.52375 13.1947 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458M7 11H12M7 13H11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 9.35418C14.2671 8.52375 13.1947 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.1947 16 14.2671 15.4762 15 14.6458M7 11H12M7 13H11M22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22V22C17.5228 22 22 17.5228 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.75947 11.75C8.7532 11.8325 8.75 11.9159 8.75 12C8.75 12.0841 8.7532 12.1675 8.75947 12.25H11C11.4142 12.25 11.75 12.5858 11.75 13C11.75 13.4142 11.4142 13.75 11 13.75H9.26091C9.83844 14.6521 10.8494 15.25 12 15.25C12.9706 15.25 13.8411 14.8255 14.4377 14.1495C14.7118 13.839 15.1857 13.8094 15.4963 14.0835C15.8069 14.3576 15.8364 14.8316 15.5623 15.1421C14.693 16.127 13.4188 16.75 12 16.75C9.99465 16.75 8.27954 15.5073 7.58276 13.75H7C6.58579 13.75 6.25 13.4142 6.25 13C6.25 12.5858 6.58579 12.25 7 12.25H7.25647C7.25217 12.1672 7.25 12.0839 7.25 12C7.25 11.9161 7.25217 11.8328 7.25647 11.75H7C6.58579 11.75 6.25 11.4142 6.25 11C6.25 10.5858 6.58579 10.25 7 10.25H7.58276C8.27954 8.49269 9.99465 7.25 12 7.25C13.4188 7.25 14.693 7.87299 15.5623 8.85788C15.8364 9.16843 15.8069 9.64238 15.4963 9.91648C15.1857 10.1906 14.7118 10.161 14.4377 9.85048C13.8411 9.17452 12.9706 8.75 12 8.75C10.8494 8.75 9.83844 9.34792 9.26091 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H8.75947Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
